const formatISODate = (isoDate) => {
  console.log(isoDate);

  const date = new Date(isoDate);

  // Extract components
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const weekday = days[date.getDay()];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  const hour = date.getHours() % 12 || 12; // Convert to 12-hour format
  const minute = String(date.getMinutes()).padStart(2, '0');
  const second = String(date.getSeconds()).padStart(2, '0');
  const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

  // Construct the formatted string
  return `${weekday}, ${month} ${day}, ${year}, ${hour}:${minute}:${second} ${ampm}`;
};

module.exports = formatISODate;
